/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Buildingapp1Inputs */

const he_header_buildingapp1 = /** @type {(inputs: Header_Buildingapp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בניית האפליקציה שלכם`)
};

const en_header_buildingapp1 = /** @type {(inputs: Header_Buildingapp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building Your Application`)
};

/**
* | output |
* | --- |
* | "Building Your Application" |
*
* @param {Header_Buildingapp1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const header_buildingapp1 = /** @type {((inputs?: Header_Buildingapp1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Buildingapp1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_header_buildingapp1(inputs)
	return en_header_buildingapp1(inputs)
});
export { header_buildingapp1 as "header_buildingApp" }